export default "__VITE_ASSET__4195e0e9__"